import { AccountantService, ClientService } from "../../../../services";
import {
	BackdropCircularProgress,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDialog,
	EnhancedSnackbar,
	IResponse,
	IServerError,
} from "@websential/cosmic-v20";
import {
	EMPLOYEE_LIST_SCREEN_SLUG,
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../../../common/constants";
import { FormProvider, useForm } from "react-hook-form";
import { Grid, useTheme } from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
	base64ToPdfFile,
	
	downloadBase64Txt,
	formatDate,
	savePdfAsFile,
	useNavigateToLogout,
	useRemoveQueriesOnUnmount
} from "../../../../common/Common";
import {
	setSelectedActivityLogActions,
	setSelectedStickyNavBar,
} from "../../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { Description } from "@mui/icons-material";
import { IAppState } from "../../../../store/reducers";
import { IDropDownListResponse } from "../../../../models/common/IDropDownListResponse";
import { IGetListRequest } from "../../../../models";
import { PaymentUploadedTransacitonsDataGrid } from "./PaymentUploadedTransacitonsDataGrid";
import { PaymentUploadedTransacitonsHeader } from "./PaymentUploadedTransacitonsHeader"
import { TransactionsServices } from "../../../../services/DirectDeposit/TransactionsServices";
import { baseAppURL } from "../../../../common/http-commons";
import { boolean } from "yup";
import { setSelectedDrawerOptionsMenu } from "../../../../store/actions/drawerMenuOptionsActions";
import { useNavigate } from "react-router-dom";

export interface IPaymentUploadedTransacitonsSetupPage { }
const PAYMENT_UPLOADED_TRANSACTIONS_QUERY_KEY = "payment-uploaded-transactions";

const usePaymentUploadedTransactions = (
	params: IGetListRequest,
	navigateToLogout: (path: any) => void
) =>
	useQuery({
		queryKey: [
			PAYMENT_UPLOADED_TRANSACTIONS_QUERY_KEY,
			params,
		],
		queryFn: () =>
			TransactionsServices.getPaymentUploadedTransacitonsList(
				params,
				navigateToLogout
			),
		refetchOnWindowFocus: false,
	});



export let paymentUploadedTransactionsFieldsTableInitialData = [
	{
		id: "1",
		file: null,
		description: null,

	},
];

export const PaymentUploadedTransactions: React.FC<IPaymentUploadedTransacitonsSetupPage> = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const navigateToLogout = useNavigateToLogout();
	const [openDialog, setDialogOpen] = useState(false);
	const [buttonTag, setButtonTag] = useState<any>(null);
	const [dialogButtonLabel, setDialogButtonLabel] = useState("");
	const [dialogContent, setDialogContent] = useState<any>(null);
	const [payPeriodPaymentDate, setPayPeriodPaymentDate] = useState<any>(null);

	// for delete row Purpose
	const queryClient = useQueryClient();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [selectedRows, setSelectedRows] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [accountantId, setAccountantId] = useState("all");
	const [paymentUploadedTransacitonsData, setPaymentUploadedTransacitonsData] =
		useState<any>(undefined);

	// paymentUploaded Add Row Table
	const [paymentUploadedFieldsTableUpdatedData, setPaymentUploadedFieldsTableUpdatedData] =
		useState(paymentUploadedTransactionsFieldsTableInitialData);
	const [paymentUploadedFieldsDataItems, setPaymentUploadedFieldsDataItems] =
		useState(paymentUploadedTransactionsFieldsTableInitialData);


	const formMethods = useForm<any>({
		mode: "onBlur",
		reValidateMode: "onChange",
	});

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "firstName",
		order_direction: "asc",
		page: 1,
		size: 25,
	});



	const { isPending, data } = usePaymentUploadedTransactions(
		queryParams,
		navigateToLogout
	);
	const PaymentUploadedTransacitonsList: any | null = data;
	
	useEffect(() => {
		if (PaymentUploadedTransacitonsList) {
			setPaymentUploadedTransacitonsData(PaymentUploadedTransacitonsList);
		}
	}, [PaymentUploadedTransacitonsList]);

	const { isPending: isSubmitting, mutate: submitPaymentUploaded } = useMutation({
				mutationFn: TransactionsServices.createPaymentUploadedFiles,
				onSuccess: (res: IServerError | IResponse | any) => {
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong!",
						severity: res.status === false ? "error" : "success",
					});
					queryClient.invalidateQueries({ queryKey: [PAYMENT_UPLOADED_TRANSACTIONS_QUERY_KEY] })
					setPaymentUploadedFieldsDataItems(paymentUploadedTransactionsFieldsTableInitialData)
				},
				onError: (err: any) => {
					setSnackbarData({
						open: true,
						// message: "Something went wrong, try again later!",
						message: err.message,
						severity: "error",
					});
				},
			});


	const convertFileToBase64 = (file: File): Promise<string> => {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result as string);
			reader.onerror = (error) => reject(error);
		});
	};

	// const onSubmit = async (values: any) => {
	// 	paymentUploadedTransacitonsDataAPICall(
	// 		values.client,
	// 		values.clientType,
	// 		values.type,
	// 		values.dateAppliesOn,
	// 		values.startDate,
	// 		values.endDate,
	// 	);
	// 	if (values.pdfFile && values.pdfFile.length > 0) {
	// 			
	// 				const file = values.pdfFile[0]
	// 				const base64 = await convertFileToBase64(file);
	// 				const cleanBase64 = base64.split(",")[1];
	// 				values.pdfFile = cleanBase64;
	// 			} else if (values.pdfFile ) {
	// 				const file = values.pdfFile;
	// 				const base64 = await convertFileToBase64(file);
	// 				const cleanBase64 = base64.split(",")[1];
	// 				values.uplosadFile = cleanBase64;
	// 			}
	// 		
	// };


	// const onSubmit = async (values: any) => {
	//     const formatPaymentUploadedFieldsTableUpdatedData = await Promise.all(
	//         paymentUploadedFieldsTableUpdatedData.map(async (x: any) => {
	//             if (x.file && x.file.length > 0) {
	//                 const file = x.file[0];
	//                 const base64 = await convertFileToBase64(file);
	//                 const cleanBase64 = base64.split(",")[1];
	//                 return {
	//                     ...x,
	//                     file: cleanBase64,
	//                     description: x.description,
	//                 };
	//             } else if (x.file) {
	//                 const file = x.file;
	//                 const base64 = await convertFileToBase64(file);
	//                 const cleanBase64 = base64.split(",")[1];
	//                 return {
	//                     ...x,
	//                     file: cleanBase64,
	//                     description: x.description,
	//                 };
	//             }
	//             return null;
	//         })
	//     );

	

	// };

	const onSubmit = async (values: any) => {
		const atLeastOneFileSelected = paymentUploadedFieldsTableUpdatedData.some(
			(x: any) => x.file !== null
		);

		if (!atLeastOneFileSelected) {
			setSnackbarData({
				open: true,
				message: "Please select at least one file",
				severity: "error",
			});
			return;
		}

		const formatPaymentUploadedFieldsTableUpdatedData = (await Promise.all(
			paymentUploadedFieldsTableUpdatedData
				.filter((x: any) => {
					const hasFile = x.file !== null && x.file !== undefined;
					return hasFile;
				})
				.map(async (x: any) => {
					if (x.file && x.file.length > 0) {
						const file = x.file[0];
						const base64 = await convertFileToBase64(file);
						const cleanBase64 = base64.split(",")[1];
						return {
							...x,
							fileName:file.name,
							file: cleanBase64,
							description: x.description,
						};
					} else if (x.file) {
						const file = x.file;
						const base64 = await convertFileToBase64(file);
						const cleanBase64 = base64.split(",")[1];
						return {
							...x,
							fileName:file.name,
							file: cleanBase64,
							description: x.description,
						};
					}
					return null;
				})
		));

		const payload = {

			...values,
			formatPaymentUploadedFieldsTableUpdatedData,
		};
	
		submitPaymentUploaded(formatPaymentUploadedFieldsTableUpdatedData)
	};

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "firstName",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	useRemoveQueriesOnUnmount(["employee-report"]);

	const updatedPaymentUploadedTransactionsListItems = useMemo(() => {
		return (
			paymentUploadedTransacitonsData &&
			paymentUploadedTransacitonsData.items &&
			paymentUploadedTransacitonsData?.items.map((item: any) => ({
				...item,
			}))
		);
	}, [paymentUploadedTransacitonsData]);

	const expandedLabels = ["Transactions", "Payment"];
	const expandedPaymentUploadedOrSetupItem = "Payment Uploaded";
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Payment" &&
				item.label === expandedPaymentUploadedOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedPaymentUploadedOrSetupItem && "/direct-deposit/transactions/payment-uploaded",
			};
			return enhancedItem;
		});
	};
	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: EMPLOYEE_LIST_SCREEN_SLUG,
				accountantName: "",
				activityType: "activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: true }));

		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
		dispatch(setSelectedStickyNavBar({ isSticky: false }));
	}, [drawerMenuOptions]);

	const onParserClickedHandler = async (params: any) => {
		let path = `${baseAppURL}#/direct-deposit/transactions/payment-uploaded/parser/${params.id}`
		// navigate(path)
		window.open(path, "_blank")
	}
	const onDownloadClickedHandler = async (params: any) => {
		(async () => {
			try {
				setIsLoading(true)
				const response: any =
					await TransactionsServices.downloadPaymentFileInProcessPaymentTransactions(params.id);
				if (response) {
					if (response.status === 400) {
						setSnackbarData({
							open: true,
							message: response.data.message
								? response.data.message
								: "Something went wrong.",
							severity: "error",
						});
					} else if(response.status === 200){
						const filename = response.data.fileName;
						downloadBase64Txt(response.data.file, filename);
					}
				}
				// queryClient.invalidateQueries({ queryKey: [IN_PROCESS_Payment_TRANSACTIONS_QUERY_KEY] })
			} catch { } finally { setIsLoading(false) }
		})();
	}
	const onViewClickedHandler = async (params: any) => {
		let path = `${baseAppURL}#/direct-deposit/transactions/payment-uploaded/view/${params.id}`
		// navigate(path)
		window.open(path, "_blank")
	}

	return (
		<>

			<div
				style={{
					margin: "15px 0",
					fontSize: "1.5rem",
					fontWeight: "bold",
					fontFamily: "'Roboto','Helvetica','Arial',sans-serif",
				}}
			>
				{"Payment Uploaded"}
			</div>

			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<PaymentUploadedTransacitonsHeader
						paymentUploadedTransactionsFieldsTableUpdatedData={(data: any) =>
							setPaymentUploadedFieldsTableUpdatedData(data)
						}
						paymentUploadedTransactionsFieldsDataItems={
							paymentUploadedFieldsDataItems
						}
					/>
				</form>
			</FormProvider>

			<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
				<BackdropCircularProgress
					open={
						isPending ||
						isLoading ||
						isSubmitting

					}
					testId="payment-uploaded-transactions"
				/>


				<PaymentUploadedTransacitonsDataGrid
					columns={
						paymentUploadedTransacitonsData?.headerColumns
							? paymentUploadedTransacitonsData.headerColumns.filter(
								(item: any) => item.field !== "id"
							)
							: []
						// paymentUploadedTransacitonsData?.headerColumns ?? []
					}
					rows={
						paymentUploadedTransacitonsData && updatedPaymentUploadedTransactionsListItems
							? updatedPaymentUploadedTransactionsListItems
							: []
						// paymentUploadedTransacitonsData?.items ?? []
						// itams
					}
					showIndexColumn={true}
					showChecboxColumn={false}
					showSettingColumn={false}
					// onImportButtonClickedHandler={onImportFileClicked}
					// onImportExcelButtonClickedHandler={onExcelToPdfClicked}
					onSnackbarMessageData={(value: any) => setSnackbarData(value)}
					totalRecords={
						paymentUploadedTransacitonsData && paymentUploadedTransacitonsData.total
							? paymentUploadedTransacitonsData.total
							: 0
					}
					initialPageSize={INITIAL_PAGE_SIZE}
					rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
					onRequestParamsChange={onRequestParamsChange}
					searchFieldPlaceholder={"Search..."}
					pageTitle={"payment uploaded"}
					selectedRows={(value: any) => setSelectedRows(value)}
					onDownloadClickedHandler={onDownloadClickedHandler}
					onParserClickedHandler={onParserClickedHandler}
					onViewClickedHandler={onViewClickedHandler}

				/>

			</Grid>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={`snackbar`}
				open={snackbarData.open}
			/>
		</>
	);
};
